import jQuery from 'jquery';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import toastr from 'toastr';
import * as types from '../constants/actionTypes';
import * as auth from '../tools/auth0.cred';
import * as api from '../tools/apiConfig';
import 'react-toastify/dist/ReactToastify.css';


export function getSpecialistBlogList(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_SPECIALIST_BLOG_LIST, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					if (data) {
						response.data.data.success = true;
						return dispatch({ type: types.GET_SPECIALIST_BLOG_LIST, blogList: response.data.data })
					}
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}


export function addSpecialistBlog(data, props) {
	return function (dispatch, getState) {
		var formData = new FormData();
		formData.append('file', data.file)
		formData.append('userId', data.specialistId)
		formData.append('blogTitle', data.blogTitle)
		formData.append('description', data.description)
		if (data.blogId) {
			formData.append('blogId', data.blogId)
		}
		axios.post(api.ADD_SPECIALIST_BLOG, formData, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					toast.info("Blog add successfully");
					props.history.push('/specialist/my-blog');
					toast.info(response.data.message);
					response.data.data.success = true;
					return dispatch({ type: types.ADD_SPECIALIST_BLOG, blogDetails: response.data.data })


				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });

	}
}

export function deleteSpecialistBlog(objectDocument, blogId) {
	return function (dispatch, getState) {
		var data = {
			blogId: blogId
		}
		axios.post(api.DELETE_SPECIALIST_BLOG, { blogId: blogId, userId: objectDocument.userId }, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {

				if (response.data.code == 200) {
					toast.info("Blog delete successfully");
					toast.info(response.data.message);
					axios.post(api.GET_SPECIALIST_BLOG_LIST, objectDocument, {
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + localStorage.token
						}
					})
						.then(function (response) {
							if (response.data.code == 200) {
								response.data.data.success = true;
								return dispatch({ type: types.GET_SPECIALIST_BLOG_LIST, blogList: response.data.data })
							} else {
								toast.error(response.data.message)
								response.data.data.success = false;
								return dispatch({ type: types.GET_SPECIALIST_BLOG_LIST, blogList: response.data.data })
							}
						})
						.catch(function (error) {
						});
				}

			})
			.catch(function (error) {
			});
	}
}

export function getSpecialistBlogById(blogId, userId = '') {
	
	let obj = {}
	if (userId) {
		obj = { blogId: blogId, userId: userId };
	} else {
		obj = { blogId: blogId };
	}
	return function (dispatch, getState) {
		axios.post(api.GET_SPECIALIST_BLOG_BY_ID, obj, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				
				if (response.data.code == 200) {
					response.data.data.success = true;
					return dispatch({ type: types.GET_SPECIALIST_BLOG_BY_ID, blogData: response.data.data })
				} else {
					toast.error(response.data.message)
					response.data.data.success = false;
					return dispatch({ type: types.GET_SPECIALIST_BLOG_BY_ID, blogData: response.data.data })
				}
			})
			.catch(function (error) {
			});
	}
}

export function getAllBlogList(data, props) {
	return function (dispatch, getState) {
		axios.post(data.type == 'specialist' ? api.GET_ALL_BLOG_LIST : api.GET_ALL_ADMIN_BLOG_LIST, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {

					response.data.data.success = true;
					return dispatch({ type: types.GET_ALL_BLOG_LIST, allBlogList: response.data.data })

				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}

export function likeandUnLikeBlog(data, tableData, props) {
	return function (dispatch, getState) {
		axios.post(api.LIKE_AND_UNLIKE_BLOG, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					response.data.data.success = true;
					axios.post(tableData.type == 'specialist' ? api.GET_ALL_BLOG_LIST : api.GET_ALL_ADMIN_BLOG_LIST, tableData, {
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + localStorage.token
						}
					})
						.then(function (response) {
							if (response.data.code == 200) {

								response.data.data.success = true;
								return dispatch({ type: types.GET_ALL_BLOG_LIST, allBlogList: response.data.data })

							} else if (response.data.code == 402) {
								localStorage.clear();
								props.history.push('/');
								toastr.error(response.data.message);
							}
						})

				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}

export function favouriteAndUnFavouriteBlog(data, tableData, props) {
	return function (dispatch, getState) {
		axios.post(api.FAVOUITE_AND_UNFAVOUITE_BLOG, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					response.data.data.success = true;
					axios.post(tableData.type == 'specialist' ? api.GET_ALL_BLOG_LIST : api.GET_ALL_ADMIN_BLOG_LIST, tableData, {
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + localStorage.token
						}
					})
						.then(function (response) {
							if (response.data.code == 200) {

								response.data.data.success = true;
								return dispatch({ type: types.GET_ALL_BLOG_LIST, allBlogList: response.data.data })

							} else if (response.data.code == 402) {
								localStorage.clear();
								props.history.push('/');
								toastr.error(response.data.message);
							}
						})
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}

export function getBlogDetailsById(blogId) {
	return function (dispatch, getState) {
		axios.post(api.GET_BLOG_DETAILS_BY_ID, { blogId: blogId }, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					response.data.data.success = true;
					return dispatch({ type: types.GET_BLOG_DETAILS_BY_ID, blogDetailData: response.data.data })
				} else {
					toast.error(response.data.message)
					response.data.data.success = false;
					return dispatch({ type: types.GET_SPECIALIST_BLOG_BY_ID, blogDetailData: response.data.data })
				}
			})
			.catch(function (error) {
			});
	}
}


export function getMarketingAllBlogList(data, props) {
	return function (dispatch, getState) {
		axios.post(data.type == 'specialist' ? api.GET_MARKETING_ALL_BLOG_LIST : api.GET_MARKETING_ALL_BLOG_LIST_ADMIN, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {

					response.data.data.success = true;
					return dispatch({ type: types.GET_MARKETING_ALL_BLOG_LIST, allMarketingBlogList: response.data.data })

				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}


export function getMarketingBlogDetailsById(data) {
	return function (dispatch, getState) {
		axios.post(data.type == 'specialist' ? api.GET_MARKETING_BLOG_DETAILS_BY_ID : api.GET_ADMIN_BLOG_DETAILS_BY_ID , data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					response.data.data.success = true;
					return dispatch({ type: types.GET_MARKETING_BLOG_DETAILS_BY_ID, marketingBlogDetailData: response.data.data })
				} else {
					toast.error(response.data.message)
					response.data.data.success = false;
					return dispatch({ type: types.GET_MARKETING_BLOG_DETAILS_BY_ID, marketingBlogDetailData: response.data.data })
				}
			})
			.catch(function (error) {
			});
	}
}

